/* ── he-gift · behaviour of the gift block (snippets/he-gift.liquid) ─────────────
   2026-10-24 · CODE_TASK_CART_GIFT_CANONICAL. One script for the Archive add sheet
   and the cart drawer, so the two can never drift.

   Cart attributes (cart-level: one switch marks the whole order):
     switch on   → gift "true"  (+ the current message, and the email if valid)
     switch off  → gift "false", gift_recipient_email "" (the message is kept)
     message     → gift_message, saved 500 ms after typing stops and on blur
     email       → gift_recipient_email, saved on blur when valid or empty
   _gift_enabled / _hide_prices are blanked on every switch change, as theme.js did.
   Saves are merged while one is in flight, so nothing is dropped.
   Every instance on the page shows the same state: a change in one is sent to the
   others ("he:gift"); the drawer is rendered from the cart attributes and the sheet
   reads /cart.js when it opens.

   No focus is moved on switch-on (on iPhone it raised the keyboard over the drawer).

   API: window.HEGift.mount(el, { onToggle }) → controller
          { get(), set(state), valid(), touch(), focusEmail() }
        window.HEGift.mountAll()  · window.HEGift.readCart()  · window.HEGift.save(attrs)
*/
(function () {
  if (window.HEGift) return;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var MAX = 200;

  /* ── cart attribute saves, merged while one is in flight ── */
  var inFlight = false, pending = null;
  function save(attrs) {
    if (inFlight) { pending = Object.assign({}, pending || {}, attrs); return Promise.resolve(null); }
    inFlight = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        inFlight = false;
        if (pending) { var next = pending; pending = null; save(next); }
        return cart;
      });
  }
  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (c) { return c.attributes || {}; })
      .catch(function () { return {}; });
  }
  function track(name, props) {
    try { if (window.HE && typeof window.HE.track === 'function') window.HE.track(name, props); } catch (e) {}
  }

  function mount(root, opts) {
    if (!root) return null;
    if (root.__heGift) { if (opts && opts.onToggle) root.__heGift._onToggle = opts.onToggle; return root.__heGift; }
    var q = function (k) { return root.querySelector('[data-g="' + k + '"]'); };
    var sw = q('switch'), body = q('body'), msg = q('msg'), count = q('count'), email = q('email'), err = q('err');
    var source = root.getAttribute('data-he-gift-source') || 'sheet';
    var touched = false, timer = null;
    var ctl = { _onToggle: opts && opts.onToggle };

    function isOn() { return sw.getAttribute('aria-checked') === 'true'; }
    function text(el, t) { if (el && el.textContent !== t) el.textContent = t; } // only when it changes: WebKit drops a click whose text node is replaced
    function bad() { var v = email.value.trim(); return v !== '' && !EMAIL_RE.test(v); }
    function renderEmail() {
      var b = bad();
      email.setAttribute('aria-invalid', b ? 'true' : 'false');
      err.hidden = !(b && touched);
    }
    function renderCount() { text(count, msg.value.length + '/' + MAX); }
    function renderOn(on) {
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      body.hidden = !on;
    }
    function state() { return { on: isOn(), message: msg.value.slice(0, MAX), email: email.value.trim() }; }
    function broadcast() { document.dispatchEvent(new CustomEvent('he:gift', { detail: { from: root, state: state() } })); }

    sw.addEventListener('click', function () {
      var on = !isOn();
      renderOn(on);
      var a = { gift: on ? 'true' : 'false', _gift_enabled: '', _hide_prices: '' };
      if (on) {
        a.gift_message = msg.value.slice(0, MAX);
        if (!bad()) a.gift_recipient_email = email.value.trim();
      } else {
        email.value = ''; touched = false; renderEmail();
        a.gift_recipient_email = '';
      }
      save(a);
      broadcast();
      if (on && source === 'drawer') track('cart_gift_note_added', { has_message: !!msg.value.trim(), has_recipient_email: !!email.value.trim(), source: 'drawer' });
      if (ctl._onToggle) ctl._onToggle(on);
    });
    msg.addEventListener('input', function () {
      if (msg.value.length > MAX) msg.value = msg.value.slice(0, MAX);
      renderCount();
      clearTimeout(timer);
      timer = setTimeout(function () { timer = null; save({ gift_message: msg.value }); broadcast(); }, 500);
    });
    msg.addEventListener('blur', function () {
      if (timer) { clearTimeout(timer); timer = null; save({ gift_message: msg.value }); broadcast(); }
    });
    email.addEventListener('input', renderEmail);
    /* blur fires between mousedown and mouseup when the next tap is a button; only
       the email state is updated here, nothing else is re-rendered. */
    email.addEventListener('blur', function () {
      touched = true; renderEmail();
      if (!bad()) { save({ gift_recipient_email: email.value.trim() }); broadcast(); }
    });

    ctl.get = state;
    ctl.valid = function () { return !bad(); };
    ctl.touch = function () { touched = true; renderEmail(); };
    ctl.focusEmail = function () { try { email.focus(); } catch (e) {} };
    /* set the view only (no save); fields being edited are left alone */
    ctl.set = function (st) {
      if (!st) return;
      if (typeof st.on === 'boolean') renderOn(st.on);
      if (typeof st.message === 'string' && document.activeElement !== msg) { msg.value = st.message.slice(0, MAX); renderCount(); }
      if (typeof st.email === 'string' && document.activeElement !== email) { email.value = st.email; renderEmail(); }
      if (st.resetTouched) { touched = false; renderEmail(); }
    };
    renderCount(); renderEmail();
    root.__heGift = ctl;
    return ctl;
  }

  /* keep every instance on the page in step */
  document.addEventListener('he:gift', function (e) {
    document.querySelectorAll('[data-he-gift]').forEach(function (el) {
      if (el === e.detail.from || !el.__heGift) return;
      el.__heGift.set(e.detail.state);
    });
  });

  function mountAll() {
    document.querySelectorAll('[data-he-gift]').forEach(function (el) { mount(el); });
  }

  window.HEGift = { mount: mount, mountAll: mountAll, readCart: readCart, save: save, EMAIL_RE: EMAIL_RE };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
})();
